import React, {useCallback, useMemo} from 'react';
import {useSideBarModal} from '../../../../layout/common/useSideBarModal';
import SideBarModal from '../../../../layout/common/SideBarModal';
import ScenarioDelete from './ScenarioDelete';
import {ScenarioActionProps} from '../../../actionMenuTypes';

export const useScenarioDeleteSideBarModal = (props: Partial<ScenarioActionProps>) => {
  const {model, subModel, scenario, onSuccess} = props;
  const {buttonRef, openModal, closeModal} = useSideBarModal(scenario?.id);

  const handleSuccess = useCallback(() => {
    closeModal();
    onSuccess?.();
  }, [closeModal, onSuccess]);

  const ModalComponent = useMemo(() => {
    return (
      model &&
      subModel &&
      scenario && (
        <SideBarModal
          className="whiteTheme"
          isOpen={!!buttonRef}
          buttonRef={buttonRef}
          closeModal={closeModal}
          height={300}
        >
          <div style={{width: '40rem', paddingLeft: '3rem'}}>
            {!!buttonRef && (
              <ScenarioDelete
                model={model}
                subModel={subModel}
                scenario={scenario}
                onSuccess={handleSuccess}
                onCancel={closeModal}
              />
            )}
          </div>
        </SideBarModal>
      )
    );
  }, [buttonRef, model, subModel, scenario, closeModal, handleSuccess]);

  return {
    openModal,
    ModalComponent,
  };
};
